//** NEW TEMPLATE
import React, { useState, useEffect } from "react";

// COMPONENTS
import AllIcons from "./allIcons";

const Icon = ({ iconId, addClass, id, style, clicked }) => {
  const noIconMsg =
    process.env.NODE_ENV === "development" ? (
      <span
        data-test="Icon"
        title={"Icon name [" + iconId + "] does not exist in allIcons.js!"}
        style={{ color: "#000" }}
      >
        IC
      </span>
    ) : (
      <div data-test="Icon" id="s"></div>
    );

  const [icon, setIcon] = useState(noIconMsg);

  // set icon on render
  useEffect(() => {
    if (!AllIcons[iconId]) return;

    // set icon props
    const props = {
      children: AllIcons[iconId].props.children,
      className: `ic ${addClass ? addClass : ''}`,
      id: id ? id : "",
      "data-id": iconId,
      "data-test": "Icon",
      role: "img",
      focusable: clicked ? "true" : "false",
      // tabIndex: clicked ? "0" : "-1",
      onClick: clicked,
      "aria-hidden": "true",
      viewBox: AllIcons[iconId].props.viewBox,
      xmlns: "http://www.w3.org/2000/svg",
      style: style ? style : {},
    };

    // add props to the react element
    const createdIcon = React.cloneElement(AllIcons[iconId], props);

    setIcon(createdIcon);
  }, [iconId, addClass, id, style, clicked]);

  return icon;
};

export default Icon;
